import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { FaInfoCircle, FaEnvelope, FaBox, FaChevronDown, FaChevronUp, FaTrash } from "react-icons/fa";
//import ReCAPTCHA from "react-google-recaptcha";
import { API_CONFIG, buildApiUrl } from "../../common/api";
import { APP_CONFIG, logger } from "../../common/config";
import CandidaturaStepper from "../components/candidatura/CandidaturaStepper";
import CandidaturaSuccess from "../components/candidatura/CandidaturaSuccess";
import CandidaturaTour, { CandidaturaTourButton } from "../components/candidatura/CandidaturaTour";
import { validaBozzaMinima, validaCandidatura, calcolaProgressoCandidatura } from "../components/candidatura/validation";
import { useCandidaturaDraftParams } from "../hooks/useCandidaturaDraft";
import { trackPartnerEvent } from "../hooks/useCandidaturaAnalytics";
import heroCandidatura from "../assets/heroCandidatura.webp";
import logo from "../assets/logo.png";

export default function Candidatura() {
    const draftParams = useCandidaturaDraftParams();
    const [step, setStep] = useState(1);
    const [submitting, setSubmitting] = useState(false);
    const [submissionResult, setSubmissionResult] = useState(null);
    const [recaptchaToken, setRecaptchaToken] = useState("");
    const [showFornitore, setShowFornitore] = useState(false);
    const [showProdotti, setShowProdotti] = useState(false);
    const [showDocumenti, setShowDocumenti] = useState(false);
    const [referenti, setReferenti] = useState([{ nome: "", cognome: "", ruolo: "", recapiti: [{ tipo: "email", contatto: "", note: "" }] }]);
    const [prodotti, setProdotti] = useState([{ nome: "", descrizione: "", categoria: "" }]);
    const [documenti, setDocumenti] = useState([{ titolo: "", file: null }]);
    const [modal, setModal] = useState({ open: false, message: "" });
    const [loginModal, setLoginModal] = useState(false);
    const [loginData, setLoginData] = useState({ email: "", codice: "", loading: false });
    const [codiceAccesso, setCodiceAccesso] = useState("");  // Aggiungiamo il codice di accesso
    const [categoria, setCategoria] = useState("");
    const [messaggioCandidatura, setMessaggioCandidatura] = useState("");
    const [alert, setAlert] = useState(null);  // Aggiungiamo lo stato per gli alert
    const [loggedIn, setLoggedIn] = useState(false);
    
    // Dati del fornitore
    const [datiFornitore, setDatiFornitore] = useState({
        ragioneSociale: "",
        partitaIva: "",
        codice_fiscale: "",
        codice_destinatario: "",
        pec_fe: "",
        regime_iva: "",
        sedeProduttiva: "",
        codice_amico_referente: "",
      });

    // Categorie disponibili
    const categorie = [
        "Prodotti da forno",
        "Conserve",
        "Prodotti caseari",
        "Logistica",
        "Altro"
    ];

    useEffect(() => {
        trackPartnerEvent('candidatura_view', { landing: draftParams.landing, ruolo: draftParams.ruolo });
    }, [draftParams.landing, draftParams.ruolo]);

    useEffect(() => {
        if (draftParams.categoria) {
            setCategoria(draftParams.categoria);
            setShowFornitore(true);
        }
        if (draftParams.regioneLabel) {
            setDatiFornitore((prev) => ({
                ...prev,
                sedeProduttiva: prev.sedeProduttiva || draftParams.regioneLabel,
            }));
        }
        if (draftParams.recupera) {
            setLoginModal(true);
        }
    }, [draftParams.categoria, draftParams.regioneLabel, draftParams.recupera]);

    // Recupero dati automatico dopo salvataggio (senza modale bentornato)
    const recuperaDatiAutomatico = async (codiceAccesso, email) => {
        try {
            const url = buildApiUrl(API_CONFIG.ENDPOINTS.CANDIDATURE_RECUPERA);
            
            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                },
                body: JSON.stringify({
                    codice_accesso: codiceAccesso,
                    email: email
                })
            });

            if (!response.ok) {
                console.warn('Errore nel recupero automatico dei dati:', response.status);
                return;
            }

            const result = await response.json();
            
            if (result.success && result.candidatura) {
                // IMPORTANTE: Dopo il salvataggio, impostiamo solo i dati di stato
                // senza sovrascrivere i dati che l'utente ha appena inserito
                //console.log(result);
                inserisciDatiCandidaturaRecuperata(result);

                //console.log('✅ Stato di accesso aggiornato automaticamente dopo salvataggio');
                //console.log('📝 Mantenuti i dati correnti per evitare perdita di file/documenti');
            }
        } catch (error) {
            console.warn('Errore nel recupero automatico:', error);
        }
    };

    const inserisciDatiCandidaturaRecuperata = (result) => {
        //console.log(result)
        const candidatura = result.candidatura;
                //logger.log('🔍 Struttura candidatura ricevuta:', candidatura);
                
                // Imposta il codice di accesso per le operazioni future
                setCodiceAccesso(loginData.codice);
                
                // Popola i dati del form con quelli recuperati
                setCategoria(candidatura.categoria || "");
                setMessaggioCandidatura(candidatura.messaggio_candidatura || "");
                
                // Usa la struttura corretta dei dati dal backend
                const datiFornitore = candidatura.datiFornitore || {};
                setDatiFornitore({
                    ragioneSociale: datiFornitore.ragioneSociale || "",
                    partitaIva: datiFornitore.partitaIva || "",
                    codice_fiscale: datiFornitore.codice_fiscale || "",
                    codice_destinatario: datiFornitore.codice_destinatario || "",
                    pec_fe: datiFornitore.pec_fe || "",
                    regime_iva: datiFornitore.regime_iva || "",
                    sedeProduttiva: datiFornitore.sedeProduttiva || "",
                    codice_amico_referente: datiFornitore.codice_amico_referente || "",
                });
                
                // Imposta i referenti con la struttura corretta
                const referentiData = datiFornitore.referenti || [];
                if (referentiData.length > 0) {
                    setReferenti(referentiData);

                    setShowFornitore(true);
                } else {
                    // Mantieni almeno un referente vuoto se non ce ne sono
                    //setReferenti([{ nome: "", cognome: "", ruolo: "", recapiti: [{ tipo: "", contatto: "", note: "" }] }]);

                    setShowFornitore(false);
                }
                
                // Imposta i prodotti con le foto come preview
                const prodottiData = candidatura.prodotti || [];
                if (prodottiData.length > 0) {
                    setProdotti(prodottiData.map(prod => {
                        // Separa le foto per tipo
                        const fotoProdotto = (prod.foto || [])
                            .filter(f => f.tipo === 'prodotto')
                            .map(f => ({ 
                                id: f.id, 
                                url: `${API_CONFIG.BASE_URL}/api/candidature/${candidatura.codice_accesso}/foto/${f.id}/preview`, 
                                preview: `${API_CONFIG.BASE_URL}/api/candidature/${candidatura.codice_accesso}/foto/${f.id}/preview`, 
                                isExisting: true 
                            }));
                        
                        const fotoVendita = (prod.foto || [])
                            .filter(f => f.tipo === 'vendita')
                            .map(f => ({ 
                                id: f.id, 
                                url: `${API_CONFIG.BASE_URL}/api/candidature/${candidatura.codice_accesso}/foto/${f.id}/preview`, 
                                preview: `${API_CONFIG.BASE_URL}/api/candidature/${candidatura.codice_accesso}/foto/${f.id}/preview`, 
                                isExisting: true 
                            }));
                        
                        return {
                            nome: prod.nome || "",
                            descrizione: prod.descrizione || "",
                            categoria: prod.categoria || "",
                            produzioneGiornaliera: prod.produzioneGiornaliera || "",
                            tempoPreavviso: prod.tempoPreavviso || "",
                            costoProduzione: prod.costoProduzione || "",
                            ore_max_trasporto: prod.ore_max_trasporto || "",
                            tipo_spedizione: prod.tipo_spedizione || "",
                            note_spedizione: prod.note_spedizione || "",
                            fotoProdotto: fotoProdotto,
                            fotoVendita: fotoVendita
                        };
                    }));
                    setShowProdotti(true);
                } else {

                    setShowProdotti(false);
                    // Mantieni almeno un prodotto vuoto se non ce ne sono
                    // setProdotti([{ nome: "", descrizione: "", categoria: "", fotoProdotto: [], fotoVendita: [] }]);
                }
                
                // Gestisci i documenti con link di download
                const documentiData = candidatura.documenti || [];
                if (documentiData.length > 0) {
                    setDocumenti(documentiData.map(doc => ({
                        id: doc.id, // ID per permettere la cancellazione
                        titolo: doc.titolo || "",
                        file: null, // File fisico non disponibile
                        downloadUrl: `/api/candidature/${candidatura.codice_accesso}/documento/${doc.id}`, // URL sicuro per il download
                        isExisting: true
                    })));
                    // Aggiungi un documento vuoto per permettere di aggiungerne altri
                    setDocumenti(prev => [...prev, { titolo: "", file: null }]);

                    setShowDocumenti(true);
                } else {

                    setShowDocumenti(false);
                    // setDocumenti([{ titolo: "", file: null }]);
                }
                
                /*logger.log('✅ Dati popolati nel form:', {
                    categoria: candidatura.categoria,
                    datiFornitore,
                    referenti: referentiData,
                    prodotti: prodottiData
                });*/
    };

    const recuperaDati = async () => {
        try {
            // 🚨 MODALITÀ TEST: Simula recupero dati per test
            if (APP_CONFIG.DEVELOPMENT.ENABLE_TEST_MODE) { // Cambia a true se vuoi usare i dati mock invece dell'API reale
                ////logger.log('🧪 MODALITÀ TEST: Simulazione recupero dati');
                
                // Simula delay del server
                await new Promise(resolve => setTimeout(resolve, 1000));
                
                // Simula dati recuperati
                const candidaturaMock = {
                    categoria: "Prodotti da forno",
                    fornitore: {
                        ragione_sociale: "Azienda Recuperata SRL",
                        partita_iva: "98765432101",
                        sede_produttiva: "Via Test 456, Roma",
                        referenti: [
                            {
                                nome: "Giulia",
                                cognome: "Verdi",
                                ruolo: "Direttore Commerciale",
                                recapiti: [
                                    { tipo: "email", contatto: "giulia.verdi@test.it", note: "" },
                                    { tipo: "telefono", contatto: "+39 333 9876543", note: "Preferibile ore ufficio" }
                                ]
                            }
                        ]
                    },
                    prodotti: [
                        {
                            nome: "Focaccia Genovese",
                            descrizione: "Focaccia tradizionale ligure",
                            categoria: "Panificati"
                        }
                    ]
                };
                
                // Popola i dati del form con quelli recuperati
                setCategoria(candidaturaMock.categoria);
                setMessaggioCandidatura(candidaturaMock.messaggio_candidatura || "");
                setDatiFornitore({
                    ragioneSociale: candidaturaMock.fornitore.ragione_sociale,
                    partitaIva: candidaturaMock.fornitore.partita_iva,
                    sedeProduttiva: candidaturaMock.fornitore.sede_produttiva
                });
                setReferenti(candidaturaMock.fornitore.referenti);
                setProdotti(candidaturaMock.prodotti);
                
                setShowFornitore(true); // Apri automaticamente le sezioni con dati
                setShowProdotti(true);
                setShowDocumenti(false);
                
                return;
            }
            
            //logger.log('🌐 Modalità API reale attivata - recupero candidatura dal backend');
            
            const url = buildApiUrl(API_CONFIG.ENDPOINTS.CANDIDATURE_RECUPERA);
            
            const response = await fetch(url, {
                method: 'POST',
                headers: API_CONFIG.DEFAULT_HEADERS,
                body: JSON.stringify({
                    email: loginData.email,
                    codiceAccesso: loginData.codice  // Cambiato da 'codice' a 'codiceAccesso'
                })
            });

            if (!response.ok) {
                throw new Error('Codice di accesso o email non validi');
            }

            const result = await response.json();
            //logger.log('✅ Risposta dal server:', result);
            
            if (result.success) {
                inserisciDatiCandidaturaRecuperata(result);
            } else {
                throw new Error(result.message || 'Errore durante il recupero');
            }
            
        } catch (error) {
            //logger.error('Errore recupero candidatura:', error);
            throw error; // Rilancia l'errore per gestirlo nel chiamante
        }
    };

    // Funzione per raccogliere tutti i dati della candidatura
    const raccogliDatiCandidatura = () => {
        return {
            categoria,
            messaggioCandidatura,
            datiFornitore: {
                ragioneSociale: datiFornitore.ragioneSociale,
                partitaIva: datiFornitore.partitaIva,
                codice_fiscale: datiFornitore.codice_fiscale,
                codice_destinatario: datiFornitore.codice_destinatario,
                pec_fe: datiFornitore.pec_fe,
                regime_iva: datiFornitore.regime_iva,
                sedeProduttiva: datiFornitore.sedeProduttiva,
                codice_amico_referente: datiFornitore.codice_amico_referente || undefined,
                referenti: referenti.map(ref => ({
                    nome: ref.nome,
                    cognome: ref.cognome,
                    ruolo: ref.ruolo,
                    recapiti: ref.recapiti.map(rec => ({
                        tipo: rec.tipo,
                        contatto: rec.contatto,
                        note: rec.note
                    }))
                }))
            },
            prodotti: categoria !== "Logistica" ? prodotti.map(prod => ({
                nome: prod.nome,
                descrizione: prod.descrizione,
                categoria: prod.categoria,
                produzioneGiornaliera: prod.produzioneGiornaliera || "",
                tempoPreavviso: prod.tempoPreavviso || "",
                costoProduzione: prod.costoProduzione || "",
                ore_max_trasporto: prod.ore_max_trasporto || "",
                tipo_spedizione: prod.tipo_spedizione || "",
                note_spedizione: prod.note_spedizione || "",
                fotoProdottoCount: prod.fotoProdotto?.length || 0,
                fotoVenditaCount: prod.fotoVendita?.length || 0
            })) : [],
            documenti: documenti.filter(doc => doc.file && doc.titolo).map(doc => ({
                titolo: doc.titolo,
                hasFile: !!doc.file,
                fileName: doc.file?.name || ""
            })),
            recaptchaToken,
            timestamp: new Date().toISOString(),
            loggedIn
        };




    };

    // Funzione per creare FormData con file compatibile con Laravel
    // Funzione per creare FormData con file compatibile con Laravel
    const creaFormData = (datiCandidatura) => {
        const formData = new FormData();
        
        // Aggiungi i dati principali
        formData.append('categoria', datiCandidatura.categoria);
        formData.append('recaptcha_token', datiCandidatura.recaptchaToken || '');
        formData.append('logged_in', datiCandidatura.loggedIn ? '1' : '0');
        
        // Converti i dati della candidatura in JSON e aggiungili come campo
        const candidaturaData = {
            categoria: datiCandidatura.categoria,
            messaggioCandidatura: datiCandidatura.messaggioCandidatura,
            datiFornitore: datiCandidatura.datiFornitore,
            prodotti: datiCandidatura.prodotti.map(prod => ({
                nome: prod.nome,
                descrizione: prod.descrizione,
                categoria: prod.categoria,
                produzioneGiornaliera: prod.produzioneGiornaliera || "",
                tempoPreavviso: prod.tempoPreavviso || "",
                costoProduzione: prod.costoProduzione || "",
                ore_max_trasporto: prod.ore_max_trasporto || "",
                tipo_spedizione: prod.tipo_spedizione || "",
                note_spedizione: prod.note_spedizione || "",
            })),
            documenti: datiCandidatura.documenti.map(doc => ({
                titolo: doc.titolo
            })),
            recaptchaToken: datiCandidatura.recaptchaToken,
            loggedIn: datiCandidatura.loggedIn
        };
        
        formData.append('candidatura', JSON.stringify(candidaturaData));
        
        // Aggiungi le foto dei prodotti
        prodotti.forEach((prodotto, prodIndex) => {
            if (prodotto.fotoProdotto && prodotto.fotoProdotto.length > 0) {
                prodotto.fotoProdotto.forEach((file, fileIndex) => {
                    formData.append(`prodotto_${prodIndex}_foto_prodotto_${fileIndex}`, file);
                });
            }
            if (prodotto.fotoVendita && prodotto.fotoVendita.length > 0) {
                prodotto.fotoVendita.forEach((file, fileIndex) => {
                    formData.append(`prodotto_${prodIndex}_foto_vendita_${fileIndex}`, file);
                });
            }
        });
        
        // Aggiungi i documenti
        let documentoIndex = 0;
        documenti.forEach((documento) => {
            if (documento.file && documento.titolo) {
                formData.append(`documento_${documentoIndex}`, documento.file);
                documentoIndex++;
            }
        });
        
        // Log di debug per vedere cosa stiamo inviando
        /*logger.log('📦 FormData creato:', {
            prodottiFoto: prodotti.reduce((acc, p, i) => {
                if (p.fotoProdotto?.length) acc[`prodotto_${i}_foto_prodotto`] = p.fotoProdotto.length;
                if (p.fotoVendita?.length) acc[`prodotto_${i}_foto_vendita`] = p.fotoVendita.length;
                return acc;
            }, {}),
            documenti: documenti.filter(d => d.file && d.titolo).length,
            hasCandidaturaJSON: true
        });*/
        
        return formData;
    };

    // Funzione per validare la candidatura — vedi components/candidatura/validation.js

    const progresso = calcolaProgressoCandidatura(raccogliDatiCandidatura());

    const goToStep = (nextStep) => {
        trackPartnerEvent('candidatura_step', { step: nextStep, action: 'navigate' });
        setStep(nextStep);
        if (nextStep === 1) setShowFornitore(true);
        if (nextStep === 2) {
            setShowFornitore(true);
            setShowProdotti(true);
        }
        if (nextStep === 3) {
            setShowDocumenti(true);
        }
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    const extractCodiceAccesso = (result) =>
        result?.data?.candidatura?.codice_accesso
        || result?.data?.codice_accesso
        || result?.data?.codice
        || codiceAccesso
        || '';

    const handleSubmitSuccess = (type, result, datiCandidatura) => {
        const codice = extractCodiceAccesso(result);
        if (codice) {
            setCodiceAccesso(codice);
            setLoggedIn(true);
        }
        setSubmissionResult({
            type,
            codiceAccesso: codice,
            emailNotifica: result?.data?.email_notifica ?? null,
        });
        setModal({ open: false, message: '' });
        goToStep(5);
        trackPartnerEvent('candidatura_step', { step: 5, action: type });
    };

    const handleNextStep = () => {
        const dati = raccogliDatiCandidatura();
        if (step === 1) {
            if (!dati.categoria) {
                showModal('Seleziona una categoria per continuare.');
                return;
            }
            setShowFornitore(true);
        }
        if (step === 2 && categoria !== 'Logistica' && dati.prodotti.length === 0) {
            showModal('Aggiungi almeno un prodotto oppure torna indietro e scegli la categoria Logistica.');
            return;
        }
        goToStep(Math.min(step + 1, 4));
    };

    const handlePrevStep = () => goToStep(Math.max(step - 1, 1));

    // Funzione per inviare la candidatura al server Laravel (API separata)
    const inviaCandidaturaAlServer = async (datiCandidatura, isDraft = false) => {
        try {
            //logger.log('📤 Invio candidatura al server');
            //logger.log('📊 Dati candidatura:', JSON.stringify(datiCandidatura, null, 2));
            
            // 🚨 MODALITÀ TEST: Simula risposta del server per test
            if (APP_CONFIG.DEVELOPMENT.ENABLE_TEST_MODE) { // Cambia a false quando il backend è pronto
                //logger.log('🧪 MODALITÀ TEST: Simulazione invio al server');
                //logger.log('📤 Dati che sarebbero stati inviati:', JSON.stringify(datiCandidatura, null, 2));
                
                // Simula delay del server
                await new Promise(resolve => setTimeout(resolve, 1500));
                
                // Simula risposta di successo
                return { 
                    success: true, 
                    data: { 
                        id: 'test-' + Date.now(),
                        codice: 'ABC123',
                        message: isDraft ? 'Bozza salvata con successo!' : 'Candidatura inviata con successo!'
                    } 
                };
            }
            
            // Usa configurazione API centralizzata
            const endpoint = isDraft ? API_CONFIG.ENDPOINTS.CANDIDATURE_BOZZA : API_CONFIG.ENDPOINTS.CANDIDATURE;
            const url = buildApiUrl(endpoint);
            
            // Rileva se ci sono file da caricare
            const hasFiles = prodotti.some(p => p.fotoProdotto?.length || p.fotoVendita?.length) || 
                           documenti.some(d => d.file);
            
            /*logger.log('🔍 Debug invio:', {
                isDraft,
                url,
                hasFiles,
                formType: hasFiles ? 'FormData con file' : 'JSON senza file'
            });*/
            
            let requestBody;
            let headers;
            
            if (hasFiles) {
                // Se ci sono file, usa FormData
                requestBody = creaFormData(datiCandidatura);
                headers = {
                    'Accept': 'application/json',
                    ...(loggedIn && { 'Authorization': `Bearer ${loginData.codice}` })
                };
                //logger.log('📦 FormData creato con datiFornitore:', datiCandidatura.datiFornitore);
            } else {
                // Se non ci sono file, usa JSON
                const payloadData = { candidatura: JSON.stringify(datiCandidatura) };
                requestBody = JSON.stringify(payloadData);
                headers = {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    ...(loggedIn && { 'Authorization': `Bearer ${loginData.codice}` })
                };
                //logger.log('📤 JSON payload:', payloadData);
                //logger.log('📤 DatiFornitore nel JSON:', datiCandidatura.datiFornitore);
            }
            
            /*logger.log('📤 Richiesta:', {
                url,
                method: 'POST',
                headers,
                bodyType: hasFiles ? 'FormData' : 'JSON',
                bodyPreview: hasFiles ? 'FormData (file upload)' : (requestBody.substring(0, 200) + '...')
            });*/
            
            const response = await fetch(url, {
                method: 'POST',
                body: requestBody,
                headers: headers
            });

            if (!response.ok) {
                let errorMessage = `Errore del server: ${response.status}`;
                try {
                    const errorData = await response.json();
                    //logger.error('🚨 Errore dal server:', errorData);
                    errorMessage = errorData.message || errorMessage;
                    
                    // Se ci sono errori di validazione, mostrali
                    if (errorData.errors) {
                        //logger.error('📋 Errori di validazione:', errorData.errors);
                        const validationErrors = Object.values(errorData.errors).flat();
                        errorMessage = validationErrors.join(', ');
                    }
                } catch (e) {
                    //logger.error('❌ Impossibile parsare errore:', e);
                    // Se non riesce a parsare JSON, usa il messaggio di default
                }
                throw new Error(errorMessage);
            }

            const result = await response.json();
        
            const resultData = { success: true, data: result };
            const codice = result?.candidatura?.codice_accesso;
            const emailRef = datiCandidatura.datiFornitore?.referenti?.[0]?.recapiti?.[0]?.contatto;
            if (resultData.success && codice && emailRef) {
                recuperaDatiAutomatico(codice, emailRef);
            }

            return resultData;

        } catch (error) {
            //logger.error('Errore invio candidatura:', error);
            return { 
                success: false, 
                error: error.message || 'Errore durante l\'invio della candidatura' 
            };
        }
    };

    const showModal = (message) => setModal({ open: true, message });
    const closeModal = () => setModal({ open: false, message: "" });

    // Invia il token insieme agli altri dati nel submit
    /*fetch("/api/candidature", {
        method: "POST",
        body: JSON.stringify({ ...altriDati, recaptcha: recaptchaToken }),
        headers: { "Content-Type": "application/json" }
    });*/

    // Gestione referenti
    const addReferente = () => setReferenti([...referenti, { nome: "", cognome: "", ruolo: "", recapiti: [{ tipo: "email", contatto: "", note: "" }] }]);
    const removeReferente = (i) => setReferenti(referenti.filter((_, idx) => idx !== i));
    const addRecapito = (i) => {
        const newRefs = [...referenti];
        newRefs[i].recapiti.push({ tipo: "", contatto: "", note: "" });
        setReferenti(newRefs);
    };
    const removeRecapito = (rIndex, cIndex) => {
        const newRefs = [...referenti];
        
        // Non permettere di rimuovere il primo recapito se è l'unico
        if (newRefs[rIndex].recapiti.length === 1 && cIndex === 0) {
            setAlert({
                type: 'error',
                message: 'Ogni referente deve avere almeno un recapito email'
            });
            return;
        }
        
        // Non permettere di rimuovere il primo recapito se non ci sono altre email
        if (cIndex === 0) {
            const hasOtherEmails = newRefs[rIndex].recapiti.slice(1).some(rec => 
                rec.tipo === 'email' || rec.tipo === 'pec'
            );
            if (!hasOtherEmails) {
                setAlert({
                    type: 'error',
                    message: 'Ogni referente deve avere almeno un recapito email'
                });
                return;
            }
        }
        
        newRefs[rIndex].recapiti.splice(cIndex, 1);
        setReferenti(newRefs);
    };
    const handleChange = (array, setArray, index, field, value) => {
        const newArr = [...array];
        newArr[index][field] = value;
        setArray(newArr);
    };
    const handleRecapitoChange = (rIndex, cIndex, field, value) => {
        const newRefs = [...referenti];
        newRefs[rIndex].recapiti[cIndex][field] = value;
        setReferenti(newRefs);
    };

    // Funzione per ottenere il tipo di input appropriato per il recapito
    const getInputTypeForRecapito = (tipo) => {
        switch (tipo) {
            case 'email':
            case 'pec':
                return 'email';
            case 'telefono':
            case 'whatsapp':
                return 'tel';
            default:
                return 'text';
        }
    };

    // Funzione per ottenere il placeholder appropriato per il recapito
    const getPlaceholderForRecapito = (tipo) => {
        switch (tipo) {
            case 'email':
                return 'nome@esempio.com';
            case 'pec':
                return 'pec@esempio.it';
            case 'telefono':
                return '+39 123 456 7890';
            case 'whatsapp':
                return '+39 123 456 7890';
            default:
                return 'Contatto';
        }
    };

    // Funzione per validare il formato del recapito
    const isValidRecapito = (tipo, contatto) => {
        if (!contatto || contatto.trim() === '') return true; // Empty is valid (not required)
        
        switch (tipo) {
            case 'email':
            case 'pec':
                return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(contatto);
            case 'telefono':
            case 'whatsapp':
                return /^[\d\s\+\-\(\)\.]{6,}$/.test(contatto);
            default:
                return true;
        }
    };

    // Gestione prodotti
    const addProdotto = () => setProdotti([...prodotti, { nome: "", descrizione: "", categoria: "", fotoProdotto: [], fotoVendita: [] }]);
    const removeProdotto = async (i) => {
        const prodotto = prodotti[i];
        let fotoEliminateCount = 0;
        
        // Se il prodotto ha foto esistenti salvate sul server, eliminale
        if (codiceAccesso && prodotto) {
            try {
                // Elimina tutte le foto prodotto esistenti
                if (prodotto.fotoProdotto && Array.isArray(prodotto.fotoProdotto)) {
                    for (const foto of prodotto.fotoProdotto) {
                        if (foto.isExisting && foto.id) {
                            try {
                                await eliminaFotoEsistente(foto.id, i, 'prodotto', true); // true = modalità silenziosa
                                fotoEliminateCount++;
                            } catch (error) {
                                console.warn(`Errore eliminazione foto prodotto ${foto.id}:`, error);
                            }
                        }
                    }
                }
                
                // Elimina tutte le foto vendita esistenti
                if (prodotto.fotoVendita && Array.isArray(prodotto.fotoVendita)) {
                    for (const foto of prodotto.fotoVendita) {
                        if (foto.isExisting && foto.id) {
                            try {
                                await eliminaFotoEsistente(foto.id, i, 'vendita', true); // true = modalità silenziosa
                                fotoEliminateCount++;
                            } catch (error) {
                                console.warn(`Errore eliminazione foto vendita ${foto.id}:`, error);
                            }
                        }
                    }
                }
                
                // Mostra feedback all'utente
                if (fotoEliminateCount > 0) {
                    setAlert({ 
                        type: 'success', 
                        message: `Prodotto e ${fotoEliminateCount} foto associate eliminati con successo` 
                    });
                } else {
                    setAlert({ 
                        type: 'success', 
                        message: 'Prodotto eliminato con successo' 
                    });
                }
                
            } catch (error) {
                console.error('Errore durante eliminazione foto del prodotto:', error);
                setAlert({ 
                    type: 'error', 
                    message: 'Errore durante l\'eliminazione di alcune foto. Il prodotto verrà comunque rimosso.' 
                });
            }
        } else {
            // Prodotto senza foto esistenti o senza codice accesso
            setAlert({ 
                type: 'success', 
                message: 'Prodotto eliminato con successo' 
            });
        }
        
        // Rimuovi il prodotto dall'array locale
        setProdotti(prodotti.filter((_, idx) => idx !== i));
    };

    // Gestione documenti
    const addDocumento = () => setDocumenti([...documenti, { titolo: "", file: null }]);
    const removeDocumento = (i) => setDocumenti(documenti.filter((_, idx) => idx !== i));
    const handleDocumentoChange = (index, field, value) => {
        const newDocs = [...documenti];
        if (newDocs[index]) {
            newDocs[index][field] = value;
            setDocumenti(newDocs);
        }
    };

    // Elimina foto esistente dal server
    const eliminaFotoEsistente = async (fotoId, prodottoIndex, tipoFoto, silent = false) => {
        if (!codiceAccesso) {
            const errorMsg = 'Codice di accesso non disponibile';
            console.warn(errorMsg);
            throw new Error(errorMsg);
        }

        try {
            const response = await fetch(`${API_CONFIG.BASE_URL}/api/candidature/foto/${fotoId}`, {
                method: 'DELETE',
                headers: {
                    'X-Codice-Accesso': codiceAccesso,
                    'Content-Type': 'application/json'
                }
            });

            const result = await response.json();
            
            if (result.success) {
                // Rimuovi la foto dall'array locale solo se non viene chiamata in modalità batch
                // (perché removeProdotto rimuove tutto il prodotto)
                if (!silent) {
                    const newProdotti = [...prodotti];
                    if (newProdotti[prodottoIndex]) {
                        if (tipoFoto === 'prodotto' && newProdotti[prodottoIndex].fotoProdotto) {
                            newProdotti[prodottoIndex].fotoProdotto = newProdotti[prodottoIndex].fotoProdotto.filter(f => f.id !== fotoId);
                        } else if (tipoFoto === 'vendita' && newProdotti[prodottoIndex].fotoVendita) {
                            newProdotti[prodottoIndex].fotoVendita = newProdotti[prodottoIndex].fotoVendita.filter(f => f.id !== fotoId);
                        }
                        setProdotti(newProdotti);
                    }
                    
                    setAlert({ type: 'success', message: 'Foto eliminata con successo' });
                }
                
                return true;
            } else {
                const errorMsg = result.message || 'Errore nell\'eliminazione della foto';
                if (!silent) {
                    setAlert({ type: 'error', message: errorMsg });
                }
                throw new Error(errorMsg);
            }
        } catch (error) {
            const errorMsg = 'Errore di connessione durante l\'eliminazione della foto';
            console.error('Errore eliminazione foto:', error);
            if (!silent) {
                setAlert({ type: 'error', message: errorMsg });
            }
            throw error;
        }
    };

    // Elimina documento esistente dal server
    const eliminaDocumentoEsistente = async (documentoId, documentoIndex) => {
        if (!codiceAccesso) {
            setAlert({ type: 'error', message: 'Codice di accesso non disponibile' });
            return;
        }

        try {
            const response = await fetch(`${API_CONFIG.BASE_URL}/api/candidature/documento/${documentoId}`, {
                method: 'DELETE',
                headers: {
                    'X-Codice-Accesso': codiceAccesso,
                    'Content-Type': 'application/json'
                }
            });

            const result = await response.json();
            
            if (result.success) {
                // Rimuovi il documento dall'array locale
                const newDocumenti = documenti.filter((_, idx) => idx !== documentoIndex);
                setDocumenti(newDocumenti);
                
                setAlert({ type: 'success', message: 'Documento eliminato con successo' });
            } else {
                setAlert({ type: 'error', message: result.message || 'Errore nell\'eliminazione del documento' });
            }
        } catch (error) {
            //console.error('Errore eliminazione documento:', error);
            setAlert({ type: 'error', message: 'Errore di connessione durante l\'eliminazione del documento' });
        }
    };

    const submitCandidatura = async () => {
        const datiCandidatura = raccogliDatiCandidatura();
        const validazione = validaCandidatura(datiCandidatura);

        if (!validazione.valida) {
            showModal(`Errori nella candidatura:\n${validazione.errori.join('\n')}`);
            return;
        }

        setSubmitting(true);
        trackPartnerEvent('candidatura_step', { step, action: 'submit' });

        const risultato = await inviaCandidaturaAlServer(datiCandidatura, false);
        setSubmitting(false);

        if (risultato.success) {
            handleSubmitSuccess('submit', risultato, datiCandidatura);
        } else {
            showModal(`Errore durante l'invio: ${risultato.error}`);
        }
    };

    const salvaCandidatura = async () => {
        const datiCandidatura = raccogliDatiCandidatura();
        const validazione = validaBozzaMinima(datiCandidatura);

        if (!validazione.valida) {
            showModal(`Per salvare la bozza servono almeno:\n${validazione.errori.join('\n')}`);
            return;
        }

        setSubmitting(true);
        trackPartnerEvent('candidatura_step', { step, action: 'bozza' });

        const risultato = await inviaCandidaturaAlServer(datiCandidatura, true);
        setSubmitting(false);

        if (risultato.success) {
            handleSubmitSuccess('bozza', risultato, datiCandidatura);
        } else {
            showModal(`Errore durante il salvataggio: ${risultato.error}`);
        }
    };

    // Funzione per resettare il form
    const resetForm = () => {
        setCategoria("");
        setMessaggioCandidatura("");
        setDatiFornitore({
        ragioneSociale: "",
        partitaIva: "",
        codice_fiscale: "",
        codice_destinatario: "",
        pec_fe: "",
        regime_iva: "",
        sedeProduttiva: ""
      });
        setReferenti([{ nome: "", cognome: "", ruolo: "", recapiti: [{ tipo: "email", contatto: "", note: "" }] }]);
        setProdotti([{ nome: "", descrizione: "", categoria: "" }]);
        setDocumenti([{ titolo: "", file: null }]);
        setRecaptchaToken("");
        setShowFornitore(false);
        setShowProdotti(false);
        setShowDocumenti(false);
    };

    const handleCategoriaChange = (e) => {
        setCategoria(e.target.value);
        setShowFornitore(true);
        setShowProdotti(false);
        setShowDocumenti(false);
        setStep(1);
    };

    return (
        <CandidaturaTour step={step}>
        <div className="bg-[#FFFEFA] text-black min-h-screen flex flex-col items-center pb-8 sm:pb-4">
            {/* HERO */}
            <div className="w-full relative">
                <img
                    src={heroCandidatura}
                    alt="Candidati come Fornitore"
                    className="w-full h-64 object-cover object-center"
                    style={{ maxHeight: 320 }}
                />
                <div className="absolute inset-0 bg-gradient-to-b from-black/40 to-transparent rounded-b-3xl" />
                {/* Responsive container for text/logo */}
                <div className="absolute bottom-0 left-0 w-full flex flex-col items-center px-4 pb-6 sm:bottom-6 sm:left-1/2 sm:-translate-x-1/2 sm:w-auto sm:px-0 sm:text-center mt-5">
                    {/* Logo sopra la scritta */}
                    <img
                        src={logo}
                        alt="Logo"
                        className="mx-auto w-20 h-20 sm:w-24 sm:h-24 object-contain cursor-pointer"
                        style={{ maxWidth: 96, maxHeight: 96, marginTop: 16 }}
                        onClick={() => { window.location.href = "/diventa-partner"; }}
                    />
                    <h1 className="text-2xl sm:text-4xl font-extrabold mb-2 break-words" style={{color: "white"}}>
                        {draftParams.preset?.titolo || 'Candidati come produttore'}
                    </h1>
                    <p className="text-base sm:text-lg opacity-90 break-words" style={{color: "white"}}>
                        Bastano pochi dati per iniziare — ricevi il codice via email e completa quando vuoi.
                    </p>
                </div>
                <div className="fixed top-4 right-6 z-50 flex items-center gap-2">
                    <CandidaturaTourButton />
                    <button
                        onClick={() => setLoginModal(true)}
                        className="bg-[#c78244] text-white px-4 py-2 rounded-lg shadow-lg"
                    >
                        Hai già il codice?
                    </button>
                </div>
            </div>

            {/* Modale login */}
            {loginModal && (
                <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-60">
                    <div className="bg-white rounded-3xl shadow-2xl p-8 flex flex-col items-center animate-bounce-in min-w-[320px]">
                        <h2 className="text-2xl font-extrabold text-[#c78244] mb-4">Recupera la tua candidatura</h2>
                        <input
                            type="email"
                            placeholder="Email"
                            className="border p-2 w-full mb-3"
                            value={loginData.email}
                            onChange={e => setLoginData(d => ({ ...d, email: e.target.value }))}
                        />
                        <input
                            type="text"
                            placeholder="Codice di accesso"
                            className="border p-2 w-full mb-4"
                            value={loginData.codice}
                            onChange={e => setLoginData(d => ({ ...d, codice: e.target.value }))}
                        />
                        <div className="flex gap-2">
                            <button
                                onClick={() => setLoginModal(false)}
                                className="bg-gray-300 text-black px-4 py-2 rounded-lg"
                            >
                                Annulla
                            </button>
                            <button
                                onClick={async () => {
                                    if (!loginData.email || !loginData.codice) {
                                        showModal("Inserisci email e codice di accesso");
                                        return;
                                    }
                                    
                                    setLoginData(d => ({ ...d, loading: true }));
                                    
                                    try {
                                        await recuperaDati();
                                        setLoggedIn(true);
                                        setLoginModal(false);
                                        setLoginData({ email: "", codice: "", loading: false });
                                        showModal("Bentornato! Abbiamo recuperato la tua candidatura.");
                                    } catch (error) {
                                        //logger.error('Errore durante il recupero:', error);
                                        showModal("Errore: Codice di accesso o email non validi");
                                        setLoginData(d => ({ ...d, loading: false }));
                                    }
                                }}
                                className="bg-[#c78244] text-white px-4 py-2 rounded-lg"
                                disabled={loginData.loading}
                            >
                                {loginData.loading ? "Caricamento..." : "Recupera"}
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* Alert per feedback operazioni */}
            {alert && (
                <div className={`fixed top-4 right-4 z-50 px-6 py-4 rounded-lg shadow-lg text-white ${
                    alert.type === 'success' ? 'bg-green-500' : 'bg-red-500'
                }`}>
                    <div className="flex items-center gap-2">
                        <span>{alert.message}</span>
                        <button 
                            onClick={() => setAlert(null)}
                            className="ml-4 text-white hover:text-gray-200"
                        >
                            ✕
                        </button>
                    </div>
                </div>
            )}

            {/* Modale bentornato o messaggi */}
            {modal.open && (
                <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-60">
                    <div className="bg-gradient-to-br from-[#F6CF48] to-[#c78244] rounded-3xl shadow-2xl p-10 flex flex-col items-center animate-bounce-in">
                        <div className="text-5xl mb-4">{modal.message === "bentornato" ? "👋" : "ℹ"}</div>
                        <h2 className="text-2xl font-extrabold text-white mb-2 drop-shadow">
                            {modal.message === "bentornato" ? "Bentornato!" : "Messaggio"}
                        </h2>
                        <p className="text-lg text-white mb-6 text-center whitespace-pre-line">
                            {modal.message === "bentornato"
                                ? <>Abbiamo recuperato la tua candidatura.<br />Riprendi da dove hai lasciato e ricordati di salvare.</>
                                : modal.message}
                        </p>
                        <button
                            onClick={closeModal}
                            className="bg-white text-[#c78244] font-bold px-6 py-2 rounded-full shadow hover:bg-[#F6CF48] transition"
                        >
                            Chiudi
                        </button>
                    </div>
                </div>
            )}

            <style>
                {`
@keyframes bounce-in {
0% { transform: scale(0.7); opacity: 0; }
60% { transform: scale(1.05); opacity: 1; }
100% { transform: scale(1); }
}
.animate-bounce-in {
animation: bounce-in 0.5s cubic-bezier(.68,-0.55,.27,1.55);
}
`}
            </style>

                            <div className="mt-6 text-center">
                                <h1 className="font-bold text-[#c78244] text-2xl">Come funziona:</h1>
                            </div>

            {/* BOX INFORMATIVI */}
                        <div className="grid md:grid-cols-4 gap-6 p-6 w-full max-w-5xl" data-tour="candidatura-intro">
                            {[{icon:<FaInfoCircle/>,title:"Compila i dati",desc:"Inserisci i dati aziendali, referenti e recapiti richiesti.",info:"Inserisci tutti i dati richiesti per poter essere contattato e identificato correttamente."},
                                {icon:<FaBox/>,title:"Aggiungi prodotti",desc:"Descrivi i tuoi prodotti e carica le schede tecniche.",info:"Aggiungi uno o più prodotti che vuoi proporre, includendo tutte le informazioni e le foto richieste."},
                                {icon:<FaEnvelope/>,title:"Ricevi il codice",desc:"Accedi con email e codice univoco segreto per proseguire la tua candidatura.",info:"Dopo l'invio tutti i referenti riceveranno codice per accedere e modificare la candidatura."},
                                {
                                    icon: <FaChevronUp />, // icona "step successivo" / "accesso"
                                    title: "E dopo?",
                                    desc: "Appena la candidatura sarà approvata, potrai spedire gratuitamente i prodotti accettati per procedere con l’accreditamento in piattaforma.",
                                    info: "Dopo la valutazione della candidatura, se accettata, i referenti ricevono le credenziali per accedere all'area riservata. Potrai completare le informazioni aziendali, dei prodotti e firmare i contratti necessari. Prima del primo ordine riceverai le etichette personalizzate per i tuoi prodotti e potrai iniziare a collaborare con noi!"
                                }
                            ].map((step,i)=>(
                                <motion.div key={i} className="bg-white p-4 rounded-2xl shadow hover:shadow-lg flex flex-col items-center relative" whileHover={{scale:1.03}}>
                                    <div className="text-[#c78244] mb-2 text-2xl">{step.icon}</div>
                                    <h1 className="font-bold text-xl mb-1 text-[#c78244]">Step {i + 1}</h1>
                                    <h3 className="font-bold text-xl mb-1">{step.title}</h3>
                                    <p className="text-sm text-gray-600 text-center">{step.desc}</p>
                                    <button
                                        type="button"
                                        className="absolute bottom-2 right-2 text-[#c78244] hover:text-[#a05e2a] text-xl"
                                        onClick={() => showModal(step.info)}
                                        aria-label="Informazioni aggiuntive"
                                        style={{ background: "none", border: "none", padding: 0, cursor: "pointer" }}
                                    >
                                        <FaInfoCircle />
                                    </button>
                                </motion.div>
                            ))}
                        </div>

            <div className="w-full flex justify-center mt-6 mb-2">
                <CandidaturaStepper
                    step={Math.min(step, 4)}
                    progress={progresso}
                    isLogistica={categoria === 'Logistica'}
                />
            </div>

            {step < 5 && (
            <>

                        {/* SELETTORE CATEGORIA — Step 1 */}
            {step === 1 && (
            <div className="p-6 w-full max-w-3xl" data-tour="candidatura-categoria">
            
                <label className="block text-lg font-bold mb-2 text-[#c78244]">
                    <div className="flex items-center gap-2">
                            <span className="font-bold text-[#c78244]">Per cominciare, per quale categoria vuoi candidarti?</span>
                            <button
                                type="button"
                                className="text-[#c78244] hover:text-[#a05e2a] text-lg"
                                onClick={() => showModal(
                                    "Una volta selezionato questo elemento si aprirà tutto il menù di dettaglio più in basso.\n\nQuesto campo è obbligatorio, ma non è vincolante ai fini della candidatura, infatti puoi proporre prodotti di varia natura che puoi specificare nella sezione dedicata ai prodotti."
                                )}
                                aria-label="Info selezione candidatura"
                                style={{ background: "none", border: "none", padding: 0, cursor: "pointer", color: "grey" }}
                            >
                                <FaInfoCircle />
                            </button>
                        </div>
                </label>
                <select
                    className="border p-2 w-full rounded-lg"
                    value={categoria}
                    onChange={handleCategoriaChange}
                >
                    <option value="" disabled>Seleziona una categoria...</option>
                    {categorie.map(categoria => (
                        <option key={categoria} value={categoria}>{categoria}</option>
                    ))}
                </select>
            </div>
            )}

            {/* COLLAPSE */}
            {categoria && step >= 1 && step <= 3 && (
                <div className="w-full max-w-3xl">
                    {/* Collapse Fornitore — Step 1 */}
                    {step === 1 && (
                    <div className="p-6" data-tour="candidatura-bozza">
                        <button
                            onClick={() => setShowFornitore(v => !v)}
                            className="flex justify-between items-center w-full bg-[#c78244] text-white p-3 rounded-lg mb-2"
                        >
                            <span>Dati del Fornitore</span>
                            {showFornitore ? <FaChevronUp /> : <FaChevronDown />}
                        </button>
                        {showFornitore && (
                            <div className="bg-white p-4 rounded-lg shadow space-y-4">
                                <input 
                                    type="text" 
                                    placeholder="Ragione Sociale*" 
                                    name="ragioneSociale" 
                                    className="border p-2 w-full" 
                                    value={datiFornitore.ragioneSociale}
                                    onChange={(e) => setDatiFornitore(prev => ({...prev, ragioneSociale: e.target.value}))}
                                />
                                <input 
                                    type="text" 
                                    placeholder="Partita IVA*" 
                                    name="partitaIva" 
                                    className="border p-2 w-full" 
                                    value={datiFornitore.partitaIva}
                                    onChange={(e) => setDatiFornitore(prev => ({...prev, partitaIva: e.target.value}))}
                                />
                                <input 
                                    type="text" 
                                    placeholder="Codice fiscale" 
                                    name="codice_fiscale" 
                                    className="border p-2 w-full" 
                                    value={datiFornitore.codice_fiscale || ''}
                                    onChange={(e) => setDatiFornitore(prev => ({...prev, codice_fiscale: e.target.value.toUpperCase()}))}
                                />
                                <input 
                                    type="text" 
                                    placeholder="Codice destinatario SDI (7 caratteri)" 
                                    name="codice_destinatario"
                                    maxLength={7}
                                    className="border p-2 w-full" 
                                    value={datiFornitore.codice_destinatario || ''}
                                    onChange={(e) => setDatiFornitore(prev => ({...prev, codice_destinatario: e.target.value}))}
                                />
                                <input 
                                    type="email" 
                                    placeholder="PEC fatturazione elettronica" 
                                    name="pec_fe" 
                                    className="border p-2 w-full" 
                                    value={datiFornitore.pec_fe || ''}
                                    onChange={(e) => setDatiFornitore(prev => ({...prev, pec_fe: e.target.value}))}
                                />
                                <input 
                                    type="text" 
                                    placeholder="Regime IVA (es. ordinario, forfettario)" 
                                    name="regime_iva" 
                                    className="border p-2 w-full" 
                                    value={datiFornitore.regime_iva || ''}
                                    onChange={(e) => setDatiFornitore(prev => ({...prev, regime_iva: e.target.value}))}
                                />
                                <input 
                                    type="text" 
                                    placeholder="Sede produttiva" 
                                    name="sedeProduttiva" 
                                    className="border p-2 w-full" 
                                    value={datiFornitore.sedeProduttiva}
                                    onChange={(e) => setDatiFornitore(prev => ({...prev, sedeProduttiva: e.target.value}))}
                                />
                                <div className="bg-[#fff8ea] border border-[#f3deb8] rounded-md p-3">
                                    <label className="block text-sm font-medium text-[#7a4a1f] mb-1">
                                        Codice Amico (opzionale)
                                    </label>
                                    <input
                                        type="text"
                                        placeholder="Se sei stato invitato, inserisci il codice"
                                        name="codice_amico_referente"
                                        className="border p-2 w-full uppercase"
                                        value={datiFornitore.codice_amico_referente || ''}
                                        onChange={(e) => setDatiFornitore(prev => ({
                                            ...prev,
                                            codice_amico_referente: e.target.value.toUpperCase(),
                                        }))}
                                    />
                                    <p className="text-xs text-[#7a4a1f] mt-1">
                                        Chi ti ha invitato riceve una percentuale sul tuo venduto per 12 mesi.
                                    </p>
                                </div>
                                {referenti.map((ref, i) => (
                                    <div key={i} className="border p-3 rounded-md">
                                        <div className="flex justify-between items-center mb-2">
                                            <span className="font-medium">Referente {i+1}</span>
                                            <button onClick={()=>removeReferente(i)} className="text-red-500 text-sm flex items-center"><FaTrash className="mr-1"/>Rimuovi</button>
                                        </div>
                                        <input type="text" placeholder="Nome Referente*" className="border p-2 w-full mb-2" value={ref.nome} onChange={(e)=>handleChange(referenti,setReferenti,i,"nome",e.target.value)} />
                                        <input type="text" placeholder="Cognome Referente*" className="border p-2 w-full mb-2" value={ref.cognome} onChange={(e)=>handleChange(referenti,setReferenti,i,"cognome",e.target.value)} />
                                        <input type="text" placeholder="Ruolo in azienda" className="border p-2 w-full mb-2" value={ref.ruolo} onChange={(e)=>handleChange(referenti,setReferenti,i,"ruolo",e.target.value)} />
                                        {ref.recapiti.map((rec,j)=>(
                                            <div key={j} className="flex flex-col sm:flex-row gap-2 mb-2 items-stretch sm:items-center">
                                                <select
                                                    className="border p-2 flex-1 min-w-0"
                                                    value={rec.tipo}
                                                    onChange={(e) => handleRecapitoChange(i, j, "tipo", e.target.value)}
                                                    disabled={j === 0} // Il primo recapito deve rimanere email
                                                >
                                                    <option value="">Seleziona tipo...</option>
                                                    <option value="telefono">Telefono</option>
                                                    <option value="whatsapp">WhatsApp</option>
                                                    <option value="email">Email</option>
                                                    <option value="pec">PEC</option>
                                                </select>
                                                {j === 0 && (
                                                    <div className="text-xs text-gray-500 self-center">
                                                        (Obbligatorio)
                                                    </div>
                                                )}
                                                <input
                                                    type={getInputTypeForRecapito(rec.tipo)}
                                                    placeholder={getPlaceholderForRecapito(rec.tipo)}
                                                    className={`border p-2 flex-1 min-w-0 ${
                                                        rec.contatto && !isValidRecapito(rec.tipo, rec.contatto) 
                                                            ? 'border-red-500 bg-red-50' 
                                                            : 'border-gray-300'
                                                    }`}
                                                    value={rec.contatto}
                                                    onChange={(e) => handleRecapitoChange(i, j, "contatto", e.target.value)}
                                                />
                                                {rec.contatto && !isValidRecapito(rec.tipo, rec.contatto) && (
                                                    <div className="text-red-500 text-xs mt-1">
                                                        Formato non valido per {rec.tipo}
                                                    </div>
                                                )}
                                                <input
                                                    placeholder="Note"
                                                    className="border p-2 flex-1 min-w-0"
                                                    value={rec.note}
                                                    onChange={(e) => handleRecapitoChange(i, j, "note", e.target.value)}
                                                />
                                                {j === 0 ? (
                                                    <div className="w-8 flex justify-center items-center">
                                                        <span className="text-gray-400 text-xs">📧</span>
                                                    </div>
                                                ) : (
                                                    <button
                                                        onClick={() => removeRecapito(i, j)}
                                                        className="text-red-500 text-xs self-end sm:self-center"
                                                        style={{ minWidth: "2rem" }}
                                                        aria-label="Rimuovi recapito"
                                                    >
                                                        <FaTrash />
                                                    </button>
                                                )}
                                            </div>
                                        ))}
                                        <button onClick={()=>addRecapito(i)} className="text-sm text-[#c78244]">+ Aggiungi Recapito</button>
                                    </div>
                                ))}
                                <button onClick={addReferente} className="bg-[#F6CF48] text-black p-2 rounded-md">+ Aggiungi Referente</button>
                            </div>
                        )}
                        <div className="flex items-center gap-2">
                            <button
                                type="button"
                                className="text-[#c78244] hover:text-[#a05e2a] text-lg"
                                onClick={() => showModal(
                                    "Le informazioni necessarie alla candidatura sono indicate con '*'. Consigliamo di inserire quanti più recapiti possibili e quanti più referenti (eventualmente uno per prodotto da candidare) per facilitare il processo di selezione.\nRicordiamo che è necessaria almeno un'email per referente al fine di ricevere il codice di recupero della candidatura per modificarla in seguito.\n\nSe non dovesse arrivare l'email di conferma, scrivere subito a candidatura@mangitalia.online."
                                )}
                                aria-label="Info dati fornitore e referenti"
                                style={{ background: "none", border: "none", padding: 0, cursor: "pointer", color: "grey" }}
                            >
                                <FaInfoCircle />
                            </button>
                        </div>
                    </div>
                    )}

                    {/* Step 2 — Prodotti */}
                    {step === 2 && categoria === 'Logistica' && (
                        <div className="p-6">
                            <div className="bg-[#fff8ea] border border-[#f3deb8] rounded-xl p-6 text-center text-[#7a4a1f]">
                                <p className="font-semibold mb-2">Candidatura partner logistica</p>
                                <p className="text-sm">Per i servizi di trasporto e logistica non è richiesta la scheda prodotti. Passa allo step successivo per documenti e invio.</p>
                            </div>
                        </div>
                    )}

                    {step === 2 && categoria !== "Logistica" && (
                        <div className="p-6" data-tour="candidatura-prodotti">
                            <button
                                onClick={() => setShowProdotti(v => !v)}
                                className="flex justify-between items-center w-full bg-[#c78244] text-white p-3 rounded-lg mb-2"
                            >
                                <span>Prodotti da Candidare</span>
                                {showProdotti ? <FaChevronUp /> : <FaChevronDown />}
                            </button>
                            {showProdotti && (
                                <div className="bg-white p-4 rounded-lg shadow space-y-4">
                                    {prodotti.map((p, i) => (
                                        <div key={i} className="border p-3 rounded-md">
                                            <div className="flex justify-between items-center mb-2">
                                                <span className="font-medium">Prodotto {i+1}</span>
                                                <button onClick={()=>removeProdotto(i)} className="text-red-500 text-sm flex items-center"><FaTrash className="mr-1"/>Rimuovi</button>
                                            </div>
                                            <input
                                                type="text"
                                                placeholder="Nome Prodotto"
                                                className="border p-2 w-full mb-2"
                                                value={p.nome}
                                                onChange={(e) => handleChange(prodotti, setProdotti, i, "nome", e.target.value)}
                                            />
                                            <textarea
                                                placeholder="Descrizione"
                                                className="border p-2 w-full mb-2"
                                                value={p.descrizione}
                                                onChange={(e) => handleChange(prodotti, setProdotti, i, "descrizione", e.target.value)}
                                            />
                                            {/* Foto Prodotto */}
                                            <div className="mb-4">
                                                
                                                <div className="flex items-center gap-2">
                                                    <label className="block font-semibold mb-1 text-[#c78244]">Foto del prodotto</label>
                            <button
                                type="button"
                                className="text-[#c78244] hover:text-[#a05e2a] text-lg"
                                onClick={() => showModal(
                                    "Giusto per dare una referenza, è richiesto che il prodotto venga fotografato e presentato in modo chiaro.\n Consigliamo di evidenziare dei punti di forza con le foto da specificare meglio anche nel campo della descrizione del prodotto.\n\n"
                                )}
                                aria-label="Info dati prodotti"
                                style={{ background: "none", border: "none", padding: 0, cursor: "pointer", color: "grey" }}
                            >
                                <FaInfoCircle />
                            </button>
                        </div>
                                                <div className="flex flex-wrap gap-3 mb-2">
                                                    {(p.fotoProdotto || []).map((file, idx) => (
                                                        <div key={file.isExisting ? file.url : `${idx}-${file.name}-${file.lastModified}`} className="relative group">
                                                            <img
                                                                src={file.isExisting ? file.url : URL.createObjectURL(file)}
                                                                alt="foto prodotto"
                                                                className="w-24 h-24 object-cover rounded-lg border-2 border-[#F6CF48] shadow"
                                                            />
                                                            <button
                                                                type="button"
                                                                className="absolute top-1 right-1 bg-red-500 text-white rounded-full p-1 text-xs opacity-80 group-hover:opacity-100 transition"
                                                                title="Rimuovi foto"
                                                                onClick={() => {
                                                                    if (file.isExisting && file.id) {
                                                                        // Foto esistente: elimina dal server
                                                                        eliminaFotoEsistente(file.id, i, 'prodotto');
                                                                    } else {
                                                                        // Foto nuova: rimuovi solo localmente
                                                                        const newProdotti = [...prodotti];
                                                                        if (!newProdotti[i].fotoProdotto) newProdotti[i].fotoProdotto = [];
                                                                        newProdotti[i].fotoProdotto.splice(idx, 1);
                                                                        setProdotti(newProdotti);
                                                                    }
                                                                }}
                                                            >
                                                                <FaTrash />
                                                            </button>
                                                            {file.isExisting && (
                                                                <div className="absolute bottom-1 left-1 bg-green-500 text-white rounded-full px-2 py-1 text-xs">
                                                                    Salvata
                                                                </div>
                                                            )}
                                                        </div>
                                                    ))}
                                                    <label className="flex flex-col items-center justify-center w-24 h-24 border-2 border-dashed border-[#c78244] rounded-lg cursor-pointer hover:bg-[#f6cf4820] transition">
                                                        <span className="text-2xl text-[#c78244]">+</span>
                                                        <span className="text-xs text-[#c78244] text-center">Aggiungi<br/>foto</span>
                                                        <input
                                                            type="file"
                                                            accept="image/*"
                                                            multiple
                                                            className="hidden"
                                                            onChange={e => {
                                                                const files = Array.from(e.target.files);
                                                                const newProdotti = [...prodotti];
                                                                if (!newProdotti[i].fotoProdotto) newProdotti[i].fotoProdotto = [];
                                                                newProdotti[i].fotoProdotto = newProdotti[i].fotoProdotto.concat(files);
                                                                setProdotti(newProdotti);
                                                                e.target.value = "";
                                                            }}
                                                        />
                                                    </label>
                                                </div>
                                                <p className="text-xs text-gray-500">Puoi aggiungere tutte le foto che vuoi.</p>
                                            </div>
                                            {/* Foto Vendita */}
                                            <div className="mb-4">
                                            
                                                <div className="flex items-center gap-2">
                                                    <label className="block font-semibold mb-1 text-[#c78244]">Foto presentazione di vendita (anche da bancone)</label>
                            <button
                                type="button"
                                className="text-[#c78244] hover:text-[#a05e2a] text-lg"
                                onClick={() => showModal(
                                    "Giusto per dare una referenza, è richiesto che il prodotto venga fotografato e presentato in modo chiaro per come viene distribuito oggi presso il punto vendita.\n Consigliamo di evidenziare delle peculiarità del prodotto da poter specificare meglio nella descrizione.\n\n"
                                )}
                                aria-label="Info dati prodotti vendita"
                                style={{ background: "none", border: "none", padding: 0, cursor: "pointer", color: "grey" }}
                            >
                                <FaInfoCircle />
                            </button>
                        </div>
                                                <div className="flex flex-wrap gap-3 mb-2">
                                                    {(p.fotoVendita || []).map((file, idx) => (
                                                        <div key={file.isExisting ? file.url : `${idx}-${file.name}-${file.lastModified}`} className="relative group">
                                                            <img
                                                                src={file.isExisting ? file.url : URL.createObjectURL(file)}
                                                                alt="foto vendita"
                                                                className="w-24 h-24 object-cover rounded-lg border-2 border-[#F6CF48] shadow"
                                                            />
                                                            <button
                                                                type="button"
                                                                className="absolute top-1 right-1 bg-red-500 text-white rounded-full p-1 text-xs opacity-80 group-hover:opacity-100 transition"
                                                                title="Rimuovi foto"
                                                                onClick={() => {
                                                                    if (file.isExisting && file.id) {
                                                                        // Foto esistente: elimina dal server
                                                                        eliminaFotoEsistente(file.id, i, 'vendita');
                                                                    } else {
                                                                        // Foto nuova: rimuovi solo localmente
                                                                        const newProdotti = [...prodotti];
                                                                        if (!newProdotti[i].fotoVendita) newProdotti[i].fotoVendita = [];
                                                                        newProdotti[i].fotoVendita.splice(idx, 1);
                                                                        setProdotti(newProdotti);
                                                                    }
                                                                }}
                                                            >
                                                                <FaTrash />
                                                            </button>
                                                            {file.isExisting && (
                                                                <div className="absolute bottom-1 left-1 bg-green-500 text-white rounded-full px-2 py-1 text-xs">
                                                                    Salvata
                                                                </div>
                                                            )}
                                                        </div>
                                                    ))}
                                                    <label className="flex flex-col items-center justify-center w-24 h-24 border-2 border-dashed border-[#c78244] rounded-lg cursor-pointer hover:bg-[#f6cf4820] transition">
                                                        <span className="text-2xl text-[#c78244]">+</span>
                                                        <span className="text-xs text-[#c78244] text-center">Aggiungi<br/>foto</span>
                                                        <input
                                                            type="file"
                                                            accept="image/*"
                                                            multiple
                                                            className="hidden"
                                                            onChange={e => {
                                                                const files = Array.from(e.target.files);
                                                                const newProdotti = [...prodotti];
                                                                if (!newProdotti[i].fotoVendita) newProdotti[i].fotoVendita = [];
                                                                newProdotti[i].fotoVendita = newProdotti[i].fotoVendita.concat(files);
                                                                setProdotti(newProdotti);
                                                                e.target.value = "";
                                                            }}
                                                        />
                                                    </label>
                                                </div>
                                                <p className="text-xs text-gray-500">Puoi aggiungere tutte le foto che vuoi</p>
                                            </div>
                                            <div className="mb-4 border-2 border-[#F6CF48] rounded-lg p-4">
                                                
                                                <div className="flex items-center gap-2">
                                                    <h4 className="font-semibold text-[#c78244] mb-3 text-lg">Informazioni di produzione</h4>
                            <button
                                type="button"
                                className="text-[#c78244] hover:text-[#a05e2a] text-lg"
                                onClick={() => showModal(
                                    "Non abbiamo volutamente inserito una forma di inserimento predefinita, pertanto consigliamo di inserire l'informazione nel modo più idoneo e congruo alla produzione."
                                )}
                                aria-label="Info dati produzione"
                                style={{ background: "none", border: "none", padding: 0, cursor: "pointer", color: "grey" }}
                            >
                                <FaInfoCircle />
                            </button>
                        </div>
                        <div className="text-end items-center gap-2">
                            <button
                                type="button"
                                className="text-[#c78244] hover:text-[#a05e2a] text-lg"
                                onClick={() => showModal(
                                    "In questo campo chiediamo quanta produzione si pensa di riservare o mettere a disposizione del commercio in piattaforma. La scelta è del produttore. Consigliamo di valutare opportunamente questo valore per mantenere un processo produttivo qualitativo e non intaccare il commercio locale."
                                )}
                                aria-label="Info produzione gg"
                                style={{ background: "none", border: "none", padding: 0, cursor: "pointer", color: "grey" }}
                            >
                                <FaInfoCircle />
                            </button>
                        </div>
                                                <input
                                                    type="text"
                                                    placeholder="Produzione giornaliera (es. 100 kg/gg)"
                                                    className="border p-2 w-full mb-2"
                                                    value={p.produzioneGiornaliera || ""}
                                                    onChange={e => handleChange(prodotti, setProdotti, i, "produzioneGiornaliera", e.target.value)}
                                                />

                                                <div className="text-end items-center gap-2">
                            <button
                                type="button"
                                className="text-[#c78244] hover:text-[#a05e2a] text-lg"
                                onClick={() => showModal(
                                    "In questo campo chiediamo il tempo necessario per la produzione e, quindi, il tempo di preavviso nel caso di un ordine. \nAd esempio, se un prodotto richiede 5 giorni per essere realizzato, il tempo di preavviso dovrebbe essere di almeno 5 giorni."
                                )}
                                aria-label="Info tempo produzione"
                                style={{ background: "none", border: "none", padding: 0, cursor: "pointer", color: "grey" }}
                            >
                                <FaInfoCircle />
                            </button>
                        </div>
                                                <input
                                                    type="text"
                                                    placeholder="Tempo di produzione/preavviso (es. 5 giorni)"
                                                    className="border p-2 w-full mb-2"
                                                    value={p.tempoPreavviso || ""}
                                                    onChange={e => handleChange(prodotti, setProdotti, i, "tempoPreavviso", e.target.value)}
                                                />
                                                <div className="text-end items-center gap-2">
                            <button
                                type="button"
                                className="text-[#c78244] hover:text-[#a05e2a] text-lg"
                                onClick={() => showModal(
                                    "In questo campo chiediamo quanto si pensa di voler ottenere per quel prodotto dal commercio in piattaforma. In questo caso potete esprimere l'unità di misura nella maniera più idonea alla produzione, ma consigliamo l'inserimento per kg."
                                )}
                                aria-label="Info Costo di produzione"
                                style={{ background: "none", border: "none", padding: 0, cursor: "pointer", color: "grey" }}
                            >
                                <FaInfoCircle />
                            </button>
                        </div>
                                                <input
                                                    type="text"
                                                    placeholder="Costo di produzione proposto alla piattaforma (es. € xx,xx / kg)"
                                                    className="border p-2 w-full mb-2"
                                                    value={p.costoProduzione || ""}
                                                    onChange={e => handleChange(prodotti, setProdotti, i, "costoProduzione", e.target.value)}
                                                />
                                                <input
                                                    type="number"
                                                    min="1"
                                                    max="72"
                                                    placeholder="Ore max trasporto *"
                                                    className="border p-2 w-full mb-2"
                                                    value={p.ore_max_trasporto || ""}
                                                    onChange={e => handleChange(prodotti, setProdotti, i, "ore_max_trasporto", e.target.value)}
                                                />
                                                <select
                                                    className="border p-2 w-full mb-2"
                                                    value={p.tipo_spedizione || ""}
                                                    onChange={e => handleChange(prodotti, setProdotti, i, "tipo_spedizione", e.target.value)}
                                                >
                                                    <option value="">Tipo spedizione *</option>
                                                    <option value="fresco">Fresco</option>
                                                    <option value="secco">Secco</option>
                                                    <option value="fragile">Fragile</option>
                                                </select>
                                                <input
                                                    type="text"
                                                    placeholder="Note spedizione (es. catena del freddo)"
                                                    className="border p-2 w-full mb-2"
                                                    value={p.note_spedizione || ""}
                                                    onChange={e => handleChange(prodotti, setProdotti, i, "note_spedizione", e.target.value)}
                                                />
                                                <div className="text-end items-center gap-2">
                            <button
                                type="button"
                                className="text-[#c78244] hover:text-[#a05e2a] text-lg"
                                onClick={() => showModal(
                                    "In questo campo chiediamo di entrare nello specifico delle caratteristiche del prodotto. Perchè proporlo, quali caratteristiche qualitative vuole esprimere e quali possono essere punti di forza. Consigliamo anche di inserire eventuali peculiarità produttive o di consumo per migliorare e velocizzare il processo di valutazione."
                                )}
                                aria-label="Info Descrizione"
                                style={{ background: "none", border: "none", padding: 0, cursor: "pointer", color: "grey" }}
                            >
                                <FaInfoCircle />
                            </button>
                        </div>
                                                <textarea
                                                    placeholder="Descrizione"
                                                    className="border p-2 w-full mb-2"
                                                    value={p.descrizione}
                                                    onChange={e => handleChange(prodotti, setProdotti, i, "descrizione", e.target.value)}
                                                />
                                                <div className="text-end items-center gap-2">
                            <button
                                type="button"
                                className="text-[#c78244] hover:text-[#a05e2a] text-lg"
                                onClick={() => showModal(
                                    "In questo campo vogliamo che sia il produttore a definire correttamente la categoria di prodotto. Ad esempio, in una candidatura per prodotti da forno potrebbe essere utile specificare se si tratta di pane, dolci o altri prodotti fritti. Ricordiamo che la seleziona della posizione della candidatura iniziale non è vincolante e si possono inserire tutti i prodotti desiderati di qualsiasi categoria."
                                )}
                                aria-label="Info Categoria"
                                style={{ background: "none", border: "none", padding: 0, cursor: "pointer", color: "grey" }}
                            >
                                <FaInfoCircle />
                            </button>
                        </div>
                                                <input
                                                    type="text"
                                                    placeholder="Categoria specifica"
                                                    className="border p-2 w-full"
                                                    value={p.categoria}
                                                    onChange={e => handleChange(prodotti, setProdotti, i, "categoria", e.target.value)}
                                                />
                                            </div>
                                        </div>
                                    ))}
                                    <button onClick={addProdotto} className="bg-[#F6CF48] text-black p-2 rounded-md">+ Aggiungi Prodotto</button>
                                </div>
                            )}
                            <div className="flex items-center gap-2">
                            <button
                                type="button"
                                className="text-[#c78244] hover:text-[#a05e2a] text-lg"
                                onClick={() => showModal(
                                    "Si possono inserire tutti i prodotti desiderati specificando esattamente la categoria che può non corrispondere nella categoria scelta all'inizio.\n\n Si consiglia di inserire tutte le informazioni richieste per ogni prodotto candidato per facilitare il processo di selezione. Abbiamo deciso di lasciare liberi i campi relativi alla produzione per poter inserire il dato nella forma più idonea per il produttore.\n\nPer fare un esempio: Si riservano 100kg/gg con un preavviso di 1gg per il prodotto che si sta candidando."
                                )}
                                aria-label="Info dati fornitore e referenti"
                                style={{ background: "none", border: "none", padding: 0, cursor: "pointer", color: "grey" }}
                            >
                                <FaInfoCircle />
                            </button>
                        </div>
                        </div>
                    )}

                    {/* Step 3 — Documenti */}
                    {step === 3 && (
                    <>
                    <div className="p-6" data-tour="candidatura-documenti">
                        <button
                            onClick={() => setShowDocumenti(v => !v)}
                            className="flex justify-between items-center w-full bg-[#c78244] text-white p-3 rounded-lg mb-2"
                        >
                            <span>Documenti Aggiuntivi</span>
                            {showDocumenti ? <FaChevronUp /> : <FaChevronDown />}
                        </button>
                        {showDocumenti && (
                            <div className="bg-white p-4 rounded-lg shadow space-y-4">
                                {documenti.map((doc, i) => (
                                    <div key={doc.isExisting ? `existing-${doc.downloadUrl}` : `new-${i}`} className="border p-3 rounded-md">
                                        <div className="flex justify-between items-center mb-2">
                                            <span className="font-medium">Documento {i + 1}</span>
                                            <button
                                                onClick={() => {
                                                    if (doc.isExisting && doc.id) {
                                                        // Documento esistente: elimina dal server
                                                        eliminaDocumentoEsistente(doc.id, i);
                                                    } else {
                                                        // Documento nuovo: rimuovi solo localmente
                                                        removeDocumento(i);
                                                    }
                                                }}
                                                className="text-red-500 text-sm flex items-center"
                                            >
                                                <FaTrash className="mr-1" />
                                                Rimuovi
                                            </button>
                                        </div>
                                        <input
                                            type="text"
                                            placeholder="Titolo Documento"
                                            className="border p-2 w-full mb-2"
                                            value={doc.titolo}
                                            onChange={e => handleDocumentoChange(i, "titolo", e.target.value)}
                                        />
                                        <label className="flex flex-col items-center justify-center w-full border-2 border-dashed border-[#c78244] rounded-lg cursor-pointer hover:bg-[#f6cf4820] transition mb-2">
                                            <span className="text-2xl text-[#c78244]">+</span>
                                            <span className="text-xs text-[#c78244] text-center">Aggiungi file</span>
                                            <input
                                                type="file"
                                                className="hidden"
                                                onChange={e => handleDocumentoChange(i, "file", e.target.files[0])}
                                            />
                                        </label>
                                        {doc.file && (
                                            <div className="text-xs text-gray-600 mt-1">
                                                File selezionato: <span className="font-semibold">{doc.file.name}</span>
                                            </div>
                                        )}
                                        {doc.isExisting && doc.downloadUrl && (
                                            <div className="bg-green-50 border border-green-200 rounded p-2 mt-2">
                                                <div className="flex items-center justify-between">
                                                    <span className="text-xs text-green-700">Documento salvato</span>
                                                    <a
                                                        href={doc.downloadUrl}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        className="text-blue-600 hover:text-blue-800 text-xs underline"
                                                    >
                                                        Scarica
                                                    </a>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                ))}
                                <button
                                    onClick={addDocumento}
                                    className="bg-[#F6CF48] text-black p-2 rounded-md"
                                >
                                    + Aggiungi Documento
                                </button>
                            </div>
                        )}

                        <div className="flex items-center gap-2">
                            <button
                                type="button"
                                className="text-[#c78244] hover:text-[#a05e2a] text-lg"
                                onClick={() => showModal(
                                    "Per non limitare il contatto con il team ai soli prodotti, questa sezione può essere utilizzata per caricare documenti aggiuntivi come cataloghi, brochure o schede tecniche dei prodotti o dell'azienda. Eventuali commenti nel messaggio di candidatura possono fare riferimento a questi allegati."
                                )}
                                aria-label="Info documenti aggiuntivi"
                                style={{ background: "none", border: "none", padding: 0, cursor: "pointer", color: "grey" }}
                            >
                                <FaInfoCircle />
                            </button>
                        </div>
                    </div>

                    {/* Messaggio candidatura facoltativo */}
                    <div className="p-6">
                        <div className="bg-white p-4 rounded-lg shadow space-y-4">
                            <div className="flex items-center gap-2">
                                <label className="block text-lg font-bold text-[#c78244]">
                                    Messaggio per la candidatura (facoltativo)
                                </label>
                                <button
                                    type="button"
                                    className="text-[#c78244] hover:text-[#a05e2a] text-lg"
                                    onClick={() => showModal(
                                        "Qui puoi aggiungere un messaggio personale per descrivere la tua azienda, i tuoi valori o qualsiasi informazione aggiuntiva che ritieni importante per la candidatura.\n\nQuesto campo è completamente facoltativo."
                                    )}
                                    aria-label="Info Messaggio Candidatura"
                                    style={{ background: "none", border: "none", padding: 0, cursor: "pointer" }}
                                >
                                    <FaInfoCircle />
                                </button>
                            </div>
                            <textarea
                                placeholder="Scrivi qui il tuo messaggio per la candidatura (facoltativo)..."
                                className="border p-3 w-full rounded-lg resize-vertical"
                                rows="4"
                                value={messaggioCandidatura}
                                onChange={(e) => setMessaggioCandidatura(e.target.value)}
                                maxLength="1000"
                            />
                            <div className="text-xs text-gray-500 text-right">
                                {messaggioCandidatura.length}/1000 caratteri
                            </div>
                        </div>
                    </div>
                    </>
                    )}

                    {/* Navigazione step 1-3 */}
                    {categoria && step < 4 && (
                        <div className="flex justify-between w-full max-w-3xl px-6 pb-8 gap-4" data-tour="candidatura-nav">
                            <button
                                type="button"
                                onClick={handlePrevStep}
                                disabled={step === 1}
                                className="px-5 py-2 rounded-lg border border-gray-300 disabled:opacity-40"
                            >
                                Indietro
                            </button>
                            <button
                                type="button"
                                onClick={handleNextStep}
                                className="px-5 py-2 rounded-lg bg-[#c78244] text-white font-semibold"
                            >
                                Avanti
                            </button>
                        </div>
                    )}
                </div>
            )}

            </>
            )}

            {/* Step 4 — Riepilogo e invio */}
            {categoria && step === 4 && step < 5 && (
                <div className="w-full max-w-3xl mx-auto" data-tour="candidatura-invio">
                    <div className="p-6">
                        <div className="bg-white rounded-xl shadow p-6 space-y-3 text-sm">
                            <h3 className="font-bold text-lg text-[#c78244]">Riepilogo candidatura</h3>
                            <p><strong>Categoria:</strong> {categoria}</p>
                            <p><strong>Ragione sociale:</strong> {datiFornitore.ragioneSociale || '—'}</p>
                            <p><strong>Referenti:</strong> {referenti.length}</p>
                            {categoria !== 'Logistica' && <p><strong>Prodotti:</strong> {prodotti.length}</p>}
                            <p><strong>Completamento stimato:</strong> {progresso}%</p>
                        </div>
                    </div>

                    <div className="flex flex-col items-center gap-2 mb-4 px-6">
                        <p className="text-sm text-gray-600 text-center max-w-md">
                            <strong>Salva Bozza</strong> — ricevi il codice via email, nessuna valutazione.
                            {' '}<strong>Invia Candidatura</strong> — il team inizia la revisione.
                        </p>
                    </div>

                    <div className="flex flex-wrap justify-center gap-4 p-6 mb-4">
                        <button
                            type="button"
                            onClick={handlePrevStep}
                            disabled={submitting}
                            className="px-5 py-2 rounded-lg border border-gray-300"
                        >
                            Indietro
                        </button>
                        <button
                            type="button"
                            onClick={salvaCandidatura}
                            disabled={submitting}
                            className="bg-gray-300 text-black px-4 py-2 rounded-lg disabled:opacity-50"
                        >
                            {submitting ? 'Salvataggio…' : 'Salva Bozza'}
                        </button>
                        <button
                            type="button"
                            onClick={submitCandidatura}
                            disabled={submitting}
                            className="bg-[#c78244] text-white px-4 py-2 rounded-lg disabled:opacity-50"
                        >
                            {submitting ? 'Invio in corso…' : 'Invia Candidatura'}
                        </button>
                    </div>
                </div>
            )}

            {/* Step 5 — Conferma e prossimi passi */}
            {step === 5 && submissionResult && (
                <CandidaturaSuccess
                    type={submissionResult.type}
                    codiceAccesso={submissionResult.codiceAccesso}
                    emailNotifica={submissionResult.emailNotifica}
                    onContinueDraft={() => {
                        setSubmissionResult(null);
                        goToStep(4);
                    }}
                />
            )}
        </div>
        </CandidaturaTour>
    );
}